/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFileExcel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2.5H2v19h20zm-11.515 9.482L6.835 5.5h2.937l1.992 4.143c.183.393.31.686.378.879h.026c.131-.314.269-.619.413-.915L14.71 5.5h2.695l-3.743 6.445L17.5 18.5h-2.87l-2.3-4.55a3.9 3.9 0 0 1-.275-.608h-.035a2.94 2.94 0 0 1-.266.588L9.386 18.5H6.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFillFileExcel as FillFileExcel };
